"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FileRedoSolid: function() {
        return FileRedoSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FileRedoSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 4C3 2.34315 4.34315 1 6 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289L20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4ZM14 3.5L18.5 8H15C14.4477 8 14 7.55228 14 7V3.5ZM15.1992 11.5C15.7515 11.5 16.1992 11.9477 16.1992 12.5V15.5C16.1992 16.0523 15.7515 16.5 15.1992 16.5H12.1992C11.6469 16.5 11.1992 16.0523 11.1992 15.5C11.1992 14.9477 11.6469 14.5 12.1992 14.5H13.0223C12.6694 14.1886 12.2059 14 11.6992 14C10.5946 14 9.69922 14.8954 9.69922 16C9.69922 17.1046 10.5946 18 11.6992 18C12.2121 18 12.6778 17.8083 13.0323 17.491C13.4438 17.1226 14.076 17.1577 14.4444 17.5692C14.8127 17.9807 14.7777 18.6129 14.3661 18.9812C13.6591 19.614 12.7231 20 11.6992 20C9.49008 20 7.69922 18.2091 7.69922 16C7.69922 13.7909 9.49008 12 11.6992 12C12.6457 12 13.5148 12.3286 14.1992 12.8774V12.5C14.1992 11.9477 14.6469 11.5 15.1992 11.5Z",
        fill: "currentColor"
    })
}), "FileRedoSolid");
const _default = FileRedoSolid;
